import { render, staticRenderFns } from "./singleProductEditor.vue?vue&type=template&id=b2818ee2&scoped=true"
import script from "./singleProductEditor.vue?vue&type=script&lang=js"
export * from "./singleProductEditor.vue?vue&type=script&lang=js"
import style0 from "./singleProductEditor.vue?vue&type=style&index=0&id=b2818ee2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2818ee2",
  null
  
)

export default component.exports